module.exports = __webpack_public_path__ + "img/legalleria.11b131ba.svg";